import store from '@/store'
import { routeTo } from '@/utils'

// 去认证
const toAuth = () => {
  const regType = store.state.auth.registerInfo?.regType || null
  const step = '' + (store.state.auth.step || '0')
  const stepComplete = store.state.auth.registerInfo?.stepComplete || null
  if (+regType === 1) { // 个人
    if (+stepComplete === 1) {
      return routeTo('/auth/personal/overview')
    }
    switch (step) {
      case '0':
        routeTo('/auth/personal/register')
        break
      case '1':
        routeTo('/auth/personal/businessInfo')
        break
      case '2':
        routeTo('/auth/personal/overview')
        break
    }
  } else if (+regType === 2) { // 公司
    if (+stepComplete === 1) {
      return routeTo('/auth/company/overview')
    }
    switch (step) {
      case '0':
        routeTo('/auth/company/register')
        break
      case '1':
        routeTo('/auth/company/info')
        break
      case '2':
        routeTo('/auth/company/shareholder')
        break
      case '3':
        routeTo('/auth/company/businessInfo')
        break
      case '4':
        routeTo('/auth/company/overview')
        break
    }
  } else {
    routeTo('/auth/authType')
  }
}

const handleShowOperation = () => {
  const stepComplete = store.state.auth.registerInfo?.stepComplete || ''
  const kycReviewStatus = store.state.auth.registerInfo?.kycReviewStatus || ''
  return (!stepComplete || !kycReviewStatus || (+stepComplete === 0) || (+stepComplete === 1 && ['RJ', 'RC', 'ST', 'WC'].includes(kycReviewStatus)))
}

export default {
  toAuth,
  handleShowOperation
}
